import { useContext } from 'react';

import { updateDoc, doc } from 'firebase/firestore';

import { db } from '../../../../firebase_config';

import { UserContext } from '../../../UserContext';

import { LikeIcon } from '../../../../Components/SvgComponents/LikeIcon';

export const GoodModal = ({ name, img, house, categories, price, description, id, onClose }) => {
  const { user, cart, setCart, count, setCount, sum, setSum, wishList, setWishList } = useContext(UserContext);
  const isActive = Boolean(cart.find((element) => element.id === id));
  const isInList = Boolean(wishList.find((element) => element.id === id));

  const handleAddToCart = () => {
    const userRef = doc(db, 'users', user.uid);
    const newCart = [...cart, { name, img, house, price, description, id }];

    setCart(newCart);
    setCount(count + 1);
    setSum(sum + Number(price));
    updateDoc(userRef, { cart: newCart, sum: sum + Number(price), count: count + 1 });
    onClose();
  };

  const handleRemoveFromCart = () => {
    const userRef = doc(db, 'users', user.uid);
    const newCart = cart.filter((values) => values.id !== id);

    setCart(newCart);
    setCount(count - 1);
    setSum(sum - Number(price));
    updateDoc(userRef, { cart: newCart, sum: sum - Number(price), count: count - 1 });
    onClose();
  };

  const handleToggleWishList = () => {
    const userRef = doc(db, 'users', user.uid);

    if (isInList) {
      const newWishList = wishList.filter((values) => values.id !== id);

      setWishList(newWishList);
      updateDoc(userRef, { wishList: newWishList });
    } else {
      const newWishList = [...wishList, { name, img, house, price, description, id }];

      setWishList(newWishList);
      updateDoc(userRef, { wishList: newWishList });
    }
  };

  return (
    <div className="flex smart:flex-row flex-col gap-5 items-center p-3 smart:p-5 border border-borderColor">
      <img className="block w-48 h-48 md:w-60 md:h-60 lg:w-72 lg:h-72" src={img} alt="poster" />
      <div className="pr-4 w-60 smart:w-48 md:w-60 lg:w-80 h-80 flex flex-col gap-5 overflow-y-scroll scrollbar-thin scrollbar-thumb-borderColor scrollbar-track-whiteMagic scrollbar-rounded-lg">
        <h2 className="font-crimson font-bold text-lg md:text-xl leading-6 flex tracking-wider text-center">{name}</h2>
        <hr className="w-full" />
        <p className="font-crimson font-medium text-sm leading-5 flex justify-start">{description}</p>
        <hr className="w-full" />
        <div className="flex flex-col">
          <span className="font-crimson font-bold text-lg leading-6 flex tracking-wider">Price: £{price}</span>
        </div>
        <>
          {user ? (
            <div className="flex gap-4 items-center">
              {isActive ? (
                <button
                  className="h-12 w-28 font-crimson font-normal text-lg leading-8 tracking-wider flex justify-center items-center duration-500 bg-transparent border-2 rounded-3xl border-like hover:text-font hover:bg-like"
                  onClick={handleRemoveFromCart}>
                  Depulso
                </button>
              ) : (
                <button
                  className="h-12 w-28 font-crimson font-normal text-lg leading-8 tracking-wider flex justify-center items-center duration-500 bg-transparent border-2 rounded-3xl border-borderColor hover:text-font hover:bg-borderColor"
                  onClick={handleAddToCart}>
                  Accio
                </button>
              )}
              <div className="w-8 h-8 cursor-pointer" onClick={handleToggleWishList}>
                <LikeIcon isActive={isInList} />
              </div>
            </div>
          ) : (
            <div className="font-crimson font-medium text-sm leading-5">You have to authorize for purchase</div>
          )}
        </>
      </div>
    </div>
  );
};
